import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import vuetify from './plugins/vuetify';
import '@babel/polyfill'
import i18n from './i18n'
import axios from 'axios'
import VueAxios from 'vue-axios'
import CKEditor from '@ckeditor/ckeditor5-vue';
import 'hamburgers/dist/hamburgers.css'
import 'animate.css'
import AOS from 'aos'
// import 'aos/dist/aos.css'
import 'aos/src/sass/aos.scss'
import 'aos/dist/aos.js'
Vue.use(CKEditor);
Vue.use(VueAxios, axios)
Vue.config.productionTip = false

new Vue({
  created(){
    AOS.init()
  },
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
